import {
  FETCH_GET_SPECIAL_TASK_BY_TEMPLATE_ID_REQUEST,
  FETCH_GET_SPECIAL_TASK_BY_TEMPLATE_ID_SUCCESS,
  FETCH_GET_SPECIAL_TASK_BY_TEMPLATE_ID_FALUIRE,
  
} from './getSpecialTaskByTemplateIDTypes';

const initialState = {
  loading: false,
  particularSpecialTemplateTaskInfo: null, 
  error: '',
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_GET_SPECIAL_TASK_BY_TEMPLATE_ID_REQUEST:
      return {
        ...state,
        loading: true,
      };
   

    case FETCH_GET_SPECIAL_TASK_BY_TEMPLATE_ID_SUCCESS:
      return {
        ...state,
        particularSpecialTemplateTaskInfo: action.payload,
        error: '',
        loading: false,
      };

    case FETCH_GET_SPECIAL_TASK_BY_TEMPLATE_ID_FALUIRE:
      return {
        ...state,
        loading: false,
        particularSpecialTemplateTaskInfo: null,
        error: action.payload,
      };
    default:
      return state;
  }
};

export default reducer;
